import { render, staticRenderFns } from "./ShortSentence.vue?vue&type=template&id=4be29f4f&"
import script from "./ShortSentence.vue?vue&type=script&lang=js&"
export * from "./ShortSentence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports